import React, { useEffect, useState } from "react";
import classes from "./MemeberLoanLedger.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../Components/API/Api";
import { Pencil, Trash2, Printer } from "lucide-react";
import Swal from "sweetalert2";
import logo from '../../Assets/dshbrdlogo.png';
import Select from "react-select";

const MemberLoanLedger = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedSavingsType, setSelectedSavingsType] = useState("");
  const [loading, setLoading] = useState(true);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedSupplierName, setSelectedSupplierName] = useState("");
  const [selectedSupplierId, setSelectedSupplierId] = useState("");
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [amountToBePaidInput, setAmountToBePaidInput] = useState("");
  const [customerLedgers, setCustomerLedgers] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [showLedgerButton, setShowLedgerButton] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
    const [roles, setRoles] = useState([]);

    
        const [totalDebit, setTotalDebit] = useState(0);
    const [totalCredit, setTotalCredit] = useState(0);
    const [totalBalance, setTotalBalance] = useState(0);
    const [totalSavings, setTotalSavings] = useState(0);
      const [selectedMember, setSelectedMember] = useState(null);

  // ===== Helpers =====
  const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
  };
  const formatIntegerWithCommas = (digits) => {
    if (!digits) return "";
    const n = Number(digits);
    if (isNaN(n)) return "";
    return n.toLocaleString("en-NG", { maximumFractionDigits: 0 });
  };

  const getPaymentStatus = (debtAmount, totalAmount) => {
    const debtNum = parseFloat(debtAmount || 0);
    const totalNum = parseFloat(totalAmount || 0);

    if (debtNum === 0) return { status: "Paid", className: "statusPaid" };
    if (debtNum === totalNum) return { status: "Owing", className: "statusOwing" };
    return { status: "Paid Part", className: "statusPartialPaid" };
  };
  const [modalData, setModalData] = useState({
    invoiceNumber: "",
    customerName: "",
    totalAmount: 0,
    subTotal: 0,
    outstandingBalance: 0,
    amountToBePaid: 0,
    description: "",
    transactionDate: "",
  });

  const openEditModal = (invoice) => {
    // Add null/undefined checks
    if (!invoice) {
      console.error("Invoice is undefined or null");
      return;
    }

    setSelectedInvoice(invoice);
    setModalData({
      invoiceNumber: invoice?.invoice_number || invoice?.uuid || "",
      customerName:
        invoice?.customer?.name ||
        `Customer ${invoice?.customer_id || "Unknown"}` ||
        "",
      totalAmount: parseFloat(invoice?.total_price || invoice?.amount || 0),
      subTotal: parseFloat(invoice?.sub_total || 0),
      outstandingBalance: parseFloat(invoice?.debit || invoice?.balance || 0),
      amountToBePaid: 0,
      description: invoice?.description || "",
      transactionDate: invoice?.transaction_date || "",
    });
    setAmountToBePaidInput("");

    setIsEditModalOpen(true);
  };
  const handleModalInputChange = (field, value) => {
    setModalData((prev) => {
      let updated = { ...prev };

      if (field === "amountToBePaid") {
        const digitsOnly = String(value || "").replace(/\D/g, "");
        setAmountToBePaidInput(digitsOnly);
        const parsed = digitsOnly ? parseInt(digitsOnly, 10) : 0;
        updated.amountToBePaid = parsed;
        const originalBalance = parseFloat(
          selectedInvoice?.debit || selectedInvoice?.balance || 0
        );
        const newBalance = Math.max(0, originalBalance - parsed);
        updated.outstandingBalance = newBalance;
        return updated;
      }

      updated[field] = value;

      // If amount to be paid changes, calculate new outstanding balance
      // (Handled above with formatted parsing)

      return updated;
    });
  };

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };




  // ===== Fetch Suppliers =====
  useEffect(() => {
    const fetchCustomers = async () => {
      setCustomerLoading(true);
      try {
        const res = await api.get(`/v1/member/paginate`);
        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err);
      } finally {
        setCustomerLoading(false);
      }
    };
    fetchCustomers();
  }, []);

  const fetchLedgerForCustomer = async (customerId) => {
    setLedgerLoading(true);
    try {
      const response = await api.get(`/v1/member/savings-ledger`, 
        { params: { 
          member_id: customerId,
          savings_id: selectedSavingsType,
        } 
      });

      const ledgerData = response.data.data || [];
      setCustomerLedgers(ledgerData);

      // Optional: calculate totals
      const totalBalance = ledgerData.reduce((sum, entry) => sum + parseFloat(entry.balance || 0), 0);
      const totalCredit = ledgerData.reduce((sum, entry) => sum + parseFloat(entry.credit || 0), 0);
      const totalDebt = ledgerData.reduce((sum, entry) => sum + parseFloat(entry.debit || 0), 0);

      setCustomerDetails({
        id: customerId,
        totalSales: totalBalance,
        totalPaid: totalCredit,
        totalOutstanding: totalDebt,
        totalInvoices: ledgerData.length,
      });

    } catch (error) {
      console.error("Failed to fetch ledger for customer:", error);
      setCustomerLedgers([]);
    } finally {
      setLedgerLoading(false);
    }
  };


  //   useEffect(() => {
  //     const fetchCustomersLedger = async () => {
  //       const token = localStorage.getItem("authToken");
  //       setCustomerLoading(true);
  //       try {
  //         const res = await axios.get(`${BASE_URL}/v1/customer/get-customer-ledger`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         });
  //         const customerData = res.data?.data?.data || res.data?.data || [];
  //         setCustomers(customerData);
  //       } catch (err) {
  //         console.error("Error fetching customer's Ledger:", err);
  //       } finally {
  //         setCustomerLoading(false);
  //       }
  //     };
  //     fetchCustomersLedger();
  //   }, []);


  // ===== Merge Invoice Counts =====
  const calculateMonthlyInvoices = async (customer) => {
    if (!customer?.id) return;

    try {
      // Fetch invoices for selected customer from fetch-sales-invoice
      const response = await api.get(`/v1/fetch-sales-invoice`);

      const allInvoices = response.data?.data || [];
      const customerInvoices = allInvoices.filter(
        (inv) => String(inv.customer_id) === String(customer.id)
      );

      // Filter invoices for current month
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();

      const monthlyInvoices = customerInvoices.filter((inv) => {
        const invDate = new Date(inv.transaction_date);
        return (
          invDate.getMonth() === currentMonth &&
          invDate.getFullYear() === currentYear
        );
      });

      // Ledger invoices (from customer endpoint)
      const ledgerInvoices = (customer.ledgers || []).length;

      // Merge counts
      return monthlyInvoices.length + ledgerInvoices;
    } catch (err) {
      console.error("Error calculating monthly invoices:", err);
      return 0;
    }
  };

  const handleProcess = async () => {
    setProcessing(true);
    try {
      // await new Promise((resolve) => setTimeout(resolve, 1000));
             navigate("/loans/members-loan-ledger", {
      state: {
        members: selectedMember,
        loanLedger: customerLedgers,
        memberNames: selectedSupplierName,
        memberIds: selectedSupplierId,
        savingsType: selectedSavingsType,
        totalDebit,
        totalCredit,
        totalBalance,
        totalSavings,
      },
    });
    } catch (err) {
      console.error(err);
    } finally {
      setProcessing(false);
      setShowLedgerButton(true);
    }
  };

   const fetRoles = async (memberId) => {
    setRoleLoading(true);
    try {
      const response = await api.get("/v1/member/loan_by_id", {
            params: {
              member_id: memberId,
            },
          });
      const data = response.data?.data;
      setRoles(data);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setRoles([]);
    } finally {
      setRoleLoading(false);
    }
  };

  useEffect(() => {
    fetRoles();
  }, []);

  const memberOptions = customers.map((customer) => ({
  value: customer.id,
  label: customer.name,
  ...customer,
}));

const loanOptions = roles.map((role) => ({
  value: role.loan.id,
  label: role.loan.loan_name,
}));

  const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: "0.375rem",
    fontSize: "0.875rem",
    minHeight: 40,
    height: "auto",
    // border: "0.5px solid hsla(242, 95%, 42%, 1)",
    // "&:hover": {
    //   borderColor: "#0C06AC",
    // },
  }),
    valueContainer: (base) => ({
    ...base,
    height: 40,
    padding: "0 8px",
  }),
    input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: 40,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#28a745"
      : state.isFocused
      ? "#EBFFF3"
      : "transparent",
    color: state.isSelected ? "#fff" : "inherit",
    fontSize: "0.875rem",
    cursor: "pointer",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
    fontSize: "0.875rem",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "0.875rem",
    color: "#212529",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0.375rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    zIndex: 9999,
  }),
};

  useEffect(() => {
  if (!customerLedgers.length) {
    setTotalDebit(0);
    setTotalCredit(0);
    setTotalBalance(0);
    setTotalSavings(0);
    return;
  }

  const totalDebit = customerLedgers.reduce(
    (sum, item) => sum + Number(item.debit || 0),
    0
  );

  const totalCredit = customerLedgers.reduce(
    (sum, item) => sum + Number(item.credit || 0),
    0
  );

  const totalBalance = customerLedgers.reduce(
    (sum, item) => sum + Number(item.balance || 0),
    0
  );

  setTotalDebit(totalDebit);
  setTotalCredit(totalCredit);
  setTotalBalance(totalBalance);
  setTotalSavings(customerLedgers.length);

}, [customerLedgers]);


    let runningLoanBalance = 0;
    const loanData = customerLedgers.map((row) => {
  const debit = Number(row.debit || 0);
  const credit = Number(row.credit || 0);

  runningLoanBalance =
    runningLoanBalance - debit + credit;

  return {
    ...row,
    numericRunningBalance: runningLoanBalance,
    runningBalance: formatMoney(runningLoanBalance),
  };
});

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

        {ledgerLoading && (
            <div className={classes.loadingOverlay}>
              <img src={logo} alt="Loading..." className={classes.loadingLogo} />
            </div>
          )}
      <div className={classes.Container}>
        {/* <div className={classes.actions}>
          <button
            className={classes.btns}
            onClick={() => navigate("/transactions/receivables/sales")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button className={classes.btns_ss0}>Supplier Ledger</button>
          <button
            className={`${classes.btns} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
        </div> */}

        <header className={classes.Header}>
          <h2 className={classes.Title}>Member's Loan Ledger</h2>
          <h1 className={classes.Titles}>
           View and manage members' loan ledgers, repayment history, and outstanding balances.
          </h1>
        </header>

<div className={classes.actionsRight}>
  <div className={classes.inputWrapper}>

    {/* Member */}
    <div className={classes.group} style={{ minWidth: 300 }}>
      <Select
        placeholder={
          customerLoading
            ? "Fetching members..."
            : "Search or select member"
        }
        isSearchable
        options={memberOptions}
        styles={selectStyles}
        value={
          memberOptions.find(
            (option) => option.value === selectedSupplierId
          ) || null
        }
            onChange={(selected) => {
  if (!selected) {
    setSelectedMember(null);
    setSelectedSupplierId("");
    setSelectedSupplierName("");
    setSelectedSavingsType("");

    setRoles([]);
    setCustomerLedgers([]);
    setCustomerDetails(null);

    return;
  }

  setSelectedMember(selected);

  setSelectedSupplierId(selected.id);
  setSelectedSupplierName(selected.name);

  // Clear previous data
  setSelectedSavingsType("");
  setRoles([]);
  setCustomerLedgers([]);
  setCustomerDetails(null);

  // Fetch savings products for the selected member
  fetRoles(selected.id);
}}
      />
    </div>

    {/* Loan Type */}
    <div
      className={classes.group}
      style={{ marginLeft: 10, minWidth: 250 }}
    >
      <Select
        placeholder="Select Loan Type"
        isSearchable
        isDisabled={!selectedSupplierId}
        options={loanOptions}
        styles={selectStyles}
        value={
          loanOptions.find(
            (option) => option.value === selectedSavingsType
          ) || null
        }
        onChange={async (selected) => {
          if (!selected) {
            setSelectedSavingsType("");
            setCustomerLedgers([]);
            setCustomerDetails(null);
            return;
          }

          const loanId = selected.value;
          setSelectedSavingsType(loanId);

          setLedgerLoading(true);

          try {
            const res = await api.get("/v1/member/loan-ledger", {
              params: {
                member_id: selectedSupplierId,
                loan_id: loanId,
              },
            });

            const ledgerData = res.data.data || [];

            const ledgerWithName = ledgerData.map((ledger) => ({
              ...ledger,
              supplierName: selectedSupplierName,
            }));

            setCustomerLedgers(ledgerWithName);

            const totalSales = ledgerWithName.reduce(
              (sum, entry) => sum + Number(entry.balance || 0),
              0
            );

            const totalPaid = ledgerWithName.reduce(
              (sum, entry) => sum + Number(entry.credit || 0),
              0
            );

            const totalOutstanding = ledgerWithName.reduce(
              (sum, entry) => sum + Number(entry.debit || 0),
              0
            );

            setCustomerDetails({
              id: selectedSupplierId,
              name: selectedSupplierName,
              totalSales,
              totalPaid,
              totalOutstanding,
              totalInvoices: ledgerWithName.length,
            });
          } catch (error) {
            console.error(
              "Failed to fetch member loan ledger:",
              error
            );
            setCustomerLedgers([]);
            setCustomerDetails(null);
          } finally {
            setLedgerLoading(false);
          }
        }}
      />
    </div>

    {customerLedgers.length > 0 && (
      <div className={classes.inputWrapperd}>
        <button
          type="button"
          // disabled={processing || !selectedSavingsType}
          onClick={handleProcess}
          className={classes.btnssd}
        >
            View Member's Ledger
        </button>
      </div>
    )}
  </div>
</div>

        {/* Stats */}
        {/* {customerDetails && ( */}
        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Paid</p>
                <p className={classes.kdptg1}>
                  ₦{formatMoney(totalCredit || 0)}
                  {/* 0.00 */}
                </p>
                {/* <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div> */}
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Balance</p>
                <p className={classes.kdptg2}>
                  ₦{formatMoney(totalBalance || 0)}
                  {/* 0.00 */}
                </p>
                {/* <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total  Amount</p>
                </div> */}
              </div>
            </div>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Loan</p>
                <p className={classes.kdptg3}>
                  ₦{formatMoney(totalDebit || 0)}
                  {/* 0.00 */}
                </p>
                {/* <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total Credit</p>
                </div> */}
              </div>
            </div>

            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Loan</p>
                <p className={classes.kdptg4}>
                  {totalSavings || 0}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Loan Entries</p>
                </div>
              </div>
            </div>

          </div>
        </div>
        {/* )} */}

        {/* Invoices Table */}
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>S/N</th>
                <th>Transaction Date</th>
                <th>Invoice Number</th>
                <th>Member Name</th>
                <th>Description</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Balance</th>
                {/* <th>Status</th> */}
                {/* <th>Sales Type</th> */}
                {/* <th>Post Date</th> */}
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {ledgerLoading ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                    Loading...
                  </td>
                </tr>
              ) : loanData.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                    {selectedSupplierId
                      ? "No data found for this member."
                      : "Select member to see ledger."}
                  </td>
                </tr>
              ) : (
                loanData.map((item, index) => {
                  const currentDebt = parseFloat(item.debit  || 0);
                  const currentCredit = parseFloat(item.credit || 0);
                  const totalAmount = parseFloat(item.balance || 0);
                  const paymentStatus = getPaymentStatus(currentDebt, totalAmount);

                  return (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.created_at?.split("T")[0] || "—"}</td>
                      <td>{item.invoice_number || item.uuid || "—"}</td>
                      <td>{item.supplierName || `Supplier ${item.supplier_id}`}</td>
                      <td>{item.description || "—"}</td>
                      <td style={{textAlign: 'right'}}>{formatMoney(item.debit)}</td>
                      <td style={{textAlign: 'right'}}>{formatMoney(item.credit)}</td>
                      <td style={{textAlign: 'right'}}>{item.runningBalance}</td>
                      {/* <td>
                        <span className={classes[paymentStatus.className]}>
                          {paymentStatus.status}
                        </span>
                      </td> */}
                      {/* <td>{item.created_at?.split("T")[0] || "—"}</td> */}
                      {/* <td className={classes.actionsIcons}>
                        <Pencil
                          size={16}
                          style={{ color: "rgba(22, 163, 74, 1)", cursor: "pointer" }}
                          onClick={() => openEditModal(item)}
                        />
                        <Trash2 size={16} style={{ color: "rgb(255, 2, 2)", margin: "0 6px" }} />
                        <span
                          onClick={() =>
                            navigate("/reportinvoice", { state: { invoice: item } })
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <Printer size={16} style={{ color: "rgba(37, 99, 235, 1)", cursor: "pointer" }} />
                        </span>
                      </td> */}
                    </tr>
                  );
                })
              )}
            </tbody>

          </table>

          
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MemberLoanLedger;